const oktaEnvCheck = (envStr) => {
  if (process.env[envStr] === undefined) {
   // console.error("MISSING ENV VARIABLE:  ", envStr)
  } else {
    return process.env[envStr]
  }
}

export default oktaEnvCheck
